import { COLORS_CONFIG, DEFAULT_COLORS } from '@components/widgets/apacheEchart/Commons'
import { widgetsLibrary } from '../widgetsLibrary/widgetsLibrary'
import { CommonWidgetParams, getCommonWidget } from '../dashWidgetHelper'
import { radialMapperByIndicator } from '../widgetsLibrary/widgetsLine'



export const getNode = (geoLocations: GeoDistribution[], id: number): any => {
    if (!geoLocations || geoLocations.length == 0) {
        return;
    }

    var node = undefined;
    for(var i = 0; i < geoLocations.length; ++i) {
        const geoLocation = geoLocations[i];
        if(geoLocation.id == id) {
            node = geoLocation;
            break;
        }

        node = getNode(geoLocation.children, id);
        if(node) {
            break;
        }
    };
    return node;
};

export const userHas = (geoLocations: GeoDistribution[], name: string) => {
  for (const rootGeoLocation of geoLocations) {
    if (rootGeoLocation.name.toUpperCase() == name.toUpperCase()) {
      return true;
    }
    for (const geoLocation of rootGeoLocation.children) {
      // Process each geoLocation
      if (geoLocation.name.toUpperCase() == name.toUpperCase()) {
        return true;
      }
    }
  }
  return false;
};

export const isAllFilterByLevel = (geoLocations: GeoDistribution[], filters: FiltersUI, level: string) => {
    //Para filtra por nivel Distribuidor, todos los filtros deben ser del mismo nivel
    let countGroupLevel = 0; //filters.geographicDistributions.length > 0;
    let countGroupLevelUnknown = 0;
    let countGroupLevelOthers = 0;
    for (const geoLocation of filters.geographicDistributions) {
      const node = getNode(geoLocations, geoLocation);
      if (!node?.level) {
        ++countGroupLevelUnknown;
      } else if (node.level.toUpperCase() == level) {
        ++countGroupLevel;
      } else {
        ++countGroupLevelOthers;
        break;
      }
    }

    if(countGroupLevel > 0 && countGroupLevelOthers == 0) {
      return true;
    }

    if (countGroupLevelOthers > 0) {
      return false;
    }

    for (const rootGeoLocation of geoLocations) {
      for (const geoLocation of rootGeoLocation.children) {
        // Process each geoLocation
        if (geoLocation.level.toUpperCase() == level) {
          ++countGroupLevel;
        } else {
          ++countGroupLevelOthers;
          break;
        }
      }
    }

    return (countGroupLevel > 0 && countGroupLevelOthers == 0);
}


export const GREEN_1 = '#88DD76'
export const GREEN_2 = '#AEDD76'
export const ORANGE = '#F3AF5A'
export const BLUE = '#8CF0EA'
export const RED_2 = '#DB7476'
export const RED_1 = '#CD4245'
export const YELLOW = '#F1E713'

export const CJ_HONDA_ORDER = {
  106: 0,	// Explicación Trabajo
  1007: 1,	// Entrega
  1006: 2,	// Asesor servicio
  112: 3,	// Facturación
  1: 0,	// Bienvenida
  2: 1,	// Venta Consultiva
  3: 2,	// Prueba de Manejo
  5: 3,	// Financiamiento
  7: 4,	// Seguimiento
  8: 5,	// Entrega
}

export const msurPorcRespuestasMapper = (data: any): any => {
  //console.log('porcRespuestasMapper')
  //console.log(data)
  return data !== undefined
    && data[0] !== undefined
    && data[0].resume !== undefined
    ? {
      value: data[0].resume?.answeredPerc,
      processed: data[0].resume?.processed,
      answered: data[0].resume?.answered
    }
    : {}
}

export const msurTooltipTotalRegistros = (data: any) => {
  //console.log('haTooltipTotalRegistros')
  //console.log(data)
  return "Total de envios" + ' ' + data.processed //'Total encuestas ' + data.total
}

export const suzukiCustomerJourneyMapper = (data: any, extra: any) => {
  return data.map((item: any) => {
    return {
      ...item,
      label: 'widgets.indicatorId.' + item.groupId,
      weight: CJ_HONDA_ORDER[item.groupId],
    }
  })// @ts-ignore
    .asMutable()
    .sort((item1: any, item2: any) => item1.weight - item2.weight)
}

export const suzukiCustomPieMapper = (data: any) => {
  return data.map((item: any) => ({
    id: item["group"] == null ? "Indefinido" : item["group"],
    label: item["group"] == null ? "Indefinido" : item["group"],
    value: item["value"],
  }))
}

export const getCmID = (code: string): number => {
  if (code === 'venta') return 10651
  else if (code === 'servicio' || code === 'postventa') return 10652
  else return 1
}

// Escala semáforo NPS: 0–69 rojo, 70–89 amarillo, 90–100 verde
export const HONDA_COLORS_CONFIG = [
  {
    color: RED_1,
    condition: '<=' as const,
    key: 'value',
    value: 69,
  },
  {
    color: YELLOW,
    condition: '>' as const,
    key: 'value',
    value: 69,
  },
  {
    color: GREEN_1,
    condition: '>=' as const,
    key: 'value',
    value: 90,
  },
]

export const commonWidgets: CommonWidget = {
  ...widgetsLibrary,
  multipleGaugeByQuestion: {
    ...widgetsLibrary.multipleGaugeByQuestion,
    //@ts-ignore
    config: {
      ...widgetsLibrary.multipleGaugeByQuestion.config,
      colors: HONDA_COLORS_CONFIG,
      maxValue: 5
    },
  }
}

export const HONDA_SCALE_3_COLORS = {
  'promoters': GREEN_1,
  'passives': ORANGE,
  'detractors': RED_2,
  'positive': GREEN_1,
  'neutral': ORANGE,
  'negative': RED_1,
  1: GREEN_1,
  2: ORANGE,
  3: RED_1,
}

// Indicadores del índice compuesto ponderado de scoring (hon_postvta_composite_index[_categoria]),
// devuelven "value" (puntos obtenidos, crudos) + "maximo" (tope aplicable, variable por ruteo).
// Ver limetropy2-migracion/doc/sdd/SDD_indice_compuesto_postventa.md y DECISIONS.md.
export const hondaScoringRadialMapper = (data: any, extra: any) => {
  const radialIndicators = extra?.config?.radialIndicators ?? []

  const dataWithPercent = { ...data }
  radialIndicators.forEach((indicator: string) => {
    const key = indicator + '-ld'
    const items = data[key]
    if (Array.isArray(items)) {
      dataWithPercent[key] = items.map((item: any) => {
        const maximo = Number(item.maximo)
        const value = Number(item.value)
        const percent = maximo > 0 ? (value / maximo) * 100 : item.value_norm
        return {
          ...item,
          // RadialChart usa "value" (sin sufijo) para el tooltip y "value_norm"
          // para la forma dibujada (ver radialMapperByIndicator más abajo, que
          // vuelca ambos en claves separadas). Hay que pisar los dos con el %:
          // si solo se pisa value_norm, el tooltip muestra los puntos crudos
          // (hasta 242) con el símbolo "%" pegado al lado.
          value: percent,
          value_norm: percent,
        }
      })
    }
  })

  return radialMapperByIndicator(dataWithPercent, extra)
}

const getCJIndicators = (indicatorsConfig: { [key: string]: any }) => {
  return Object.keys(indicatorsConfig).map(key => ({
    indicator: indicatorsConfig[key].name,
    grouped: undefined,
    keyExtract: ['group', 'value', 'groupId', 'maximo'],
    label: 'group',
    value: 'value',
    singleton: true,
    extras: {
      groupNameFormat: 'description',
      formula: indicatorsConfig[key].formula ?? undefined,
      ...indicatorsConfig[key].extrasFechas ?? undefined
    },
  }));
};
export const getHondaCustomerJourney = (props: {
  id: string
  indicators: { [key: string]: any },
  position?: number[],
  size: number[],
  title?: string,
  helpText?: string,
  extraConfigs?: { [key: string]: any }
  mapper?: (data: any, extra: any) => any
}) => {
  const {
    id,
    indicators,
    position,
    size,
    title,
    helpText,
    extraConfigs,
    mapper
  } = props
  return {
    title: title,
    position: position,
    size: size,
    //helpText: helpText ?? 'A excepción del NPS, las métricas mostradas son el TTB respuesta del cliente (porcentaje de menciones para las dos respuestas de mayor valor dentro de la escala)',
    showHelp: true,
    config: {
      id: id,
      type: 'multipleGauge',
      fillMode: '',
      maxValue: 100,
      //colors: COLORS_CONFIG,
      colors: HONDA_COLORS_CONFIG,
      showValues: true,
      showHistoric: false,
      mapper: mapper ?? ((data: any, extra: any) => {
        console.log('rendering CJ profuturo!')
        console.log(data)
        console.log(indicators)
        return Object.keys(data).flatMap((key) => {
          const sortedValues = data[key]
            .asMutable()
            .sort((c1: any, c2: any) => c1.groupId - c2.groupId)
            .map((item: any) => {
              const label = indicators
                ?.find((ind: any) => ind.name === key)
                ?.label

              return {
                value: item.value,
                name: key,
                label: label
              }
            });

          const item = sortedValues?.[0]
          const item2 = sortedValues?.[1]
          return item
            ? {
              label: item.label ?? `widgets.indicatorId.${item.name}`,
              value: item2 ? item.value + item2.value : item.value,
              //value: item.value
            }
            : undefined;
        });

      }),
      indicators: getCJIndicators(indicators)
    },
  }
}

export const getHondaNpsBar = (props: CommonWidgetParams): Widget => {
  const {
    name,
    commonWidgets,
    title,
    subTitle,
    position,
    size,
    render,
    showSample,
    key,
    indicator,
    mapper,
    tooltipFormatter,
    extraConfigs,
    extraIndicatorConfigs,
    url,
    extras,
    historic,
    helpText,
    parseFilters,
    targetConfig
  } = props;

  const commonWidgetConfig = getCommonWidget(props);

  if (commonWidgetConfig?.config?.indicators) {
    commonWidgetConfig.config.indicators.push(
        {
          indicator: indicator ?? 'FALTA',
          key: "monthlyNps",
          grouped: "formattedMonth",
          //groupNameFormat: "description",
          keyExtract: ['count','detractorCount','detractors','fanCount','fans','group','group_0','group_1','groupId','groupName','passiveCount','passives','promoterCount','promoterNoFanCount','promoters','promotersNoFan','value'],
          label: 'group',
          value: 'value',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
            //formula: indicatorsConfig[key].formula ?? undefined,
            //...indicatorsConfig[key].extrasFechas ?? undefined
            //formula: 'nps-10',
                    //groupByResponseValueId: 13706,//Id de la pregunta
            //groupBy: "responseValue",
            //categories: ['promoters', 'passives', 'detractors'],
          },
      }
    );

    commonWidgetConfig.config.mapper = (data: any, extra: any) => {
      console.log('rendering NPS bar!')
      console.log(data)
      const monthly = data['monthlyNps']
      const question = data['bar-by-question-nps']
      const bars = question ? question.map((item: any) => ({
        ...item,
        group: 'NPS',
        groupName: 'NPS',
        label: 'NPS',

        //group: CLIENT_PROFILE_LABELS[ item.groupId_1 ?? item.groupId], 
        //groupName: CLIENT_PROFILE_LABELS[item.groupId_1 ?? item.groupId],
        //label: CLIENT_PROFILE_LABELS[item.groupId_1 ?? item.groupId],

      })) : [];

      const barsQuestion = monthly ? monthly.map((item: any) => ({
        ...item,
        group: item.groupName,
        label: item.groupName,
      })) : [];

      return [...bars, ...barsQuestion];
    };
  }

  return commonWidgetConfig;
}